module.exports = __webpack_public_path__ + "img/gas-station-orange.e82b24a3.svg";